import { beat } from '@/src/common/animations'
import { styled } from '@/src/stitches.config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SuccessCheck = styled(FontAwesomeIcon, {
    margin: 'auto',
    pt: 10,
    pb: 20,
    animation: `${beat} 0.75s ease-in-out`,
})
